(function () {
  const config = document.getElementById('LulloShippingConfig');
  if (!config || config.dataset.country !== 'US' || config.dataset.currency !== 'USD') return;

  const threshold = Number(config.dataset.threshold || 0);
  if (!Number.isFinite(threshold) || threshold <= 0) return;

  const formatUsd = (cents) =>
    new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: cents % 100 === 0 ? 0 : 2,
      maximumFractionDigits: 2,
    }).format(cents / 100);

  const parseUsd = (value) => {
    const amount = Number.parseFloat(String(value || '').replace(/[^0-9.-]/g, ''));
    return Number.isFinite(amount) ? Math.round(amount * 100) : null;
  };

  const updateAtlasProgress = () => {
    const host = document.querySelector('.atlas-upsell-cart-progress-reward-container');
    const subtotal = document.getElementById('atlas-upsell-cart-subtotal-line-price-span');
    if (!host || !subtotal) return;

    const total = parseUsd(subtotal.textContent);
    if (total === null) return;
    const energyLines = new Map();
    host.parentElement.querySelectorAll('.atlas-upsell-cart-item-quantity-down[data-cart-item-key]').forEach((button) => {
      const key = button.dataset.cartItemKey || '';
      const quantity = Number(button.dataset.currentQuantity);
      if (key.split(':')[0] === '48700590653634' && Number.isFinite(quantity) && quantity >= 0) {
        energyLines.set(key, Math.floor(quantity));
      }
    });
    const energyQuantity = Array.from(energyLines.values()).reduce((sum, quantity) => sum + quantity, 0);
    const energyEligible = energyQuantity >= 2;
    const offerKey = `${total}:${energyQuantity}`;
    if (host.dataset.lulloOffer === offerKey && host.querySelector('.lullo-shipping-progress--atlas')) return;

    const remaining = energyEligible ? 0 : Math.max(threshold - total, 0);
    const progress = energyEligible ? 100 : Math.min(Math.max((total / threshold) * 100, 0), 100);
    const goalLabel = energyEligible ? '2+ Energy tins' : `${formatUsd(threshold)} goal`;
    const status = remaining > 0
      ? `You're ${formatUsd(remaining)} away from free US shipping.`
      : 'Free US shipping unlocked.';

    host.dataset.lulloTotal = String(total);
    host.dataset.lulloOffer = offerKey;
    host.style.display = 'block';
    host.innerHTML = `
      <div class="lullo-shipping-progress lullo-shipping-progress--atlas">
        <p class="lullo-shipping-progress__text" role="status" aria-live="polite" aria-atomic="true">${status}</p>
        <div class="lullo-shipping-progress__track" role="progressbar" aria-label="Free US shipping progress" aria-valuemin="0" aria-valuemax="100" aria-valuenow="${Math.round(progress)}" aria-valuetext="${status}">
          <span class="lullo-shipping-progress__fill" style="--lullo-shipping-progress: ${progress}%;"></span>
        </div>
        <div class="lullo-shipping-progress__meta" aria-hidden="true">
          <span>${formatUsd(total)}</span>
          <span>${goalLabel}</span>
        </div>
      </div>`;
  };

  let updateQueued = false;
  const queueUpdate = () => {
    if (updateQueued) return;
    updateQueued = true;
    window.requestAnimationFrame(() => {
      updateQueued = false;
      updateAtlasProgress();
    });
  };

  const observer = new MutationObserver(queueUpdate);
  observer.observe(document.documentElement, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['data-current-quantity', 'data-cart-item-key'] });
  document.addEventListener('cart:update', queueUpdate);
  document.addEventListener('DOMContentLoaded', queueUpdate, { once: true });
  queueUpdate();
})();

/* LULLO optional Energy cart upgrade. Uses the existing cart's pack pricing. */
(function () {
  'use strict';
  const CARD = 'lullo-energy-cart-upgrade';
  if (document.getElementById(CARD + '-styles')) return;
  const ENERGY = '48700590653634';
  const ROOT = '#atlas-upsell-cart-drawer-main-container';
  const PLUS = '.atlas-upsell-cart-item-quantity-up';
  const MINUS = '.atlas-upsell-cart-item-quantity-down';
  let busy = false;
  let timer;
  let forcePending = false;
  let revision = 0;
  let lastSignature = '';
  let successKey = '';
  let noticeSignature = '';

  // Pure eligibility check: no substitutions, subscriptions, mixed carts or extra discounts.
  function classify(cart, market, code, report = () => {}) {
    const skip = reason => { report(reason); return null; };
    if (!cart || market.country !== 'US' || market.currency !== 'USD' || cart.currency !== 'USD' || code) return skip('market-or-code');
    if (!Array.isArray(cart.items) || cart.items.length !== 1) return skip('cart-composition');
    const item = cart.items[0];
    const quantity = Number(item.quantity);
    if (String(item.variant_id) !== ENERGY || ![1, 2, 3].includes(quantity) || cart.item_count !== quantity || item.selling_plan_allocation) return skip('product-quantity-or-plan');
    if (Object.entries(item.properties || {}).some(([key, value]) => !key.startsWith('_') && value != null && value !== '')) return skip('custom-properties');
    const properties = item.properties || {};
    if (String(properties._bundle) !== '138057' || !/^\d+$/.test(String(properties._bundle_offer))) return skip('unrecognized-bundle');
    if (Object.keys(properties).some(key => key.startsWith('_') && !['_bundle', '_bundle_offer', '_offer_timestamp', '_bundle_use_compare_at'].includes(key))) return skip('special-offer-properties');
    if ((cart.cart_level_discount_applications || []).length || (cart.discount_codes || []).some(discount => discount.applicable !== false)) return skip('extra-discount');
    const expected = { 1: 2999, 2: 5699, 3: 7999 }[quantity];
    if (Number(cart.total_price) !== expected || Number(item.final_line_price) !== expected) return skip('price-mismatch');
    if (quantity === 1 && (Number(cart.total_discount || 0) !== 0 || (item.line_level_discount_allocations || []).some(allocation => Number(allocation.amount) !== 0))) return skip('single-tin-discount');
    report(quantity === 1 ? 'eligible' : 'already-bundled');
    return { key: item.key, quantity, eligible: quantity === 1, properties: JSON.stringify(Object.entries(properties).sort()) };
  }

  const style = document.createElement('style');
  style.id = CARD + '-styles';
  style.textContent = `
    ${ROOT}.lullo-energy-cart-focused .atlas-upsell-cart-carousel-container{display:none!important}
    #${CARD}{box-sizing:border-box;flex:0 0 auto;min-width:0;max-width:100%;margin:12px 16px;padding:12px;border:1px solid #e5d1d6;border-radius:8px;background:#fff8fa;color:#252525;font:13px/1.4 Inter,Arial,sans-serif;letter-spacing:0;text-align:left}
    #${CARD} *{box-sizing:border-box}
    #${CARD} h3{margin:0 0 5px;font:650 15px/1.3 Inter,Arial,sans-serif;letter-spacing:normal;text-transform:none}
    #${CARD} p{margin:0;font:inherit;overflow-wrap:break-word}
    #${CARD} .lullo-energy-upgrade-total{font-weight:650;margin-bottom:4px}
    #${CARD} .lullo-energy-upgrade-detail{margin-top:4px;color:#595154;font-size:12px}
    #${CARD} button{display:block;width:100%;min-height:44px;height:auto;margin:10px 0 0;padding:10px 12px;border:1px solid #9b1934;border-radius:7px;background:#fff;color:#85162d;font:650 14px/1.35 Inter,Arial,sans-serif;letter-spacing:normal;white-space:normal;text-transform:none;cursor:pointer;touch-action:manipulation}
    #${CARD} button:focus-visible,#${CARD}:focus-visible{outline:3px solid #252525;outline-offset:3px}
    #${CARD} button:disabled{opacity:.65;cursor:wait}
    #${CARD} [role=status]:not(:empty){margin-top:8px}
    #${CARD}[data-state=success]{padding:10px 12px}
    #${CARD}[data-state=success] [role=status]{margin:0}
    ${ROOT}.lullo-energy-cart-focused .atlas-upsell-cart-announcement:empty{display:none}
    @media(max-width:360px){
      ${ROOT}.lullo-energy-cart-focused .atlas-upsell-cart-item>div{min-width:0}
      ${ROOT}.lullo-energy-cart-focused .atlas-upsell-cart-item-info-container{flex-wrap:wrap;gap:8px}
    }
    @media(max-height:700px){
      ${ROOT}.lullo-energy-cart-focused #atlas-upsell-cart-not-empty-cart-container{overflow-y:auto;overflow-x:hidden;justify-content:flex-start}
      ${ROOT}.lullo-energy-cart-focused .atlas-upsell-cart-items-container{flex:0 0 auto;overflow:visible;min-height:0}
      ${ROOT}.lullo-energy-cart-focused .atlas-upsell-cart-footer{flex-shrink:0}
    }
  `;
  document.head.appendChild(style);

  function root() { return document.querySelector(ROOT); }
  function market() { return document.getElementById('LulloShippingConfig')?.dataset || {}; }
  function hasCode(drawer) {
    if (Array.from(drawer.querySelectorAll('#lullo-cart-discount-code-input,#atlas-discount-code-input')).some(input => input.value.trim())) return true;
    const applied = drawer.querySelector('#atlas-discount-code-applied');
    if (applied && applied.getClientRects().length && applied.textContent.trim()) return true;
    const href = drawer.querySelector('#atlas-upsell-cart-checkout-button-anchor')?.getAttribute('href') || '';
    return /[?&]discount=[^&#]+/i.test(href) || /[?&]discount=[^&#]+/i.test(location.search);
  }
  function nativeButton(drawer, selector, key, quantity) {
    return Array.from(drawer.querySelectorAll(selector)).find(button => button.dataset.cartItemKey === key && Number(button.dataset.currentQuantity) === quantity && !button.disabled && button.getAttribute('aria-disabled') !== 'true');
  }
  async function readCart() {
    const controller = new AbortController();
    const timeout = setTimeout(() => controller.abort(), 8000);
    try {
      const base = window.Shopify?.routes?.root || '/';
      const response = await fetch(base + 'cart.js', { credentials: 'same-origin', cache: 'no-store', headers: { Accept: 'application/json' }, signal: controller.signal });
      if (!response.ok) throw new Error('Cart unavailable');
      return await response.json();
    } finally { clearTimeout(timeout); }
  }
  function removeCard() {
    const card = document.getElementById(CARD);
    const focused = card?.contains(document.activeElement);
    card?.remove();
    if (focused) root()?.querySelector(PLUS)?.focus({ preventScroll: true });
  }
  function mount(drawer) {
    let card = document.getElementById(CARD);
    if (card) return card;
    const items = drawer.querySelector('.atlas-upsell-cart-items-container');
    if (!items) return null;
    card = document.createElement('section');
    card.id = CARD;
    card.setAttribute('aria-label', 'Optional two-tin upgrade');
    card.innerHTML = '<h3>Add a second tin for only $27 more</h3><p>Unlock free standard U.S. shipping.</p><p class="lullo-energy-upgrade-detail">2 tins · 60 strips · $56.99 before tax.</p><button type="button">Add second tin · +$27</button><p role="status" aria-live="polite" aria-atomic="true"></p>';
    card.querySelector('button').addEventListener('click', upgrade);
    items.insertBefore(card, items.querySelector('.atlas-upsell-cart-carousel-container'));
    return card;
  }
  function showStatus(message, success = false) {
    const drawer = root();
    if (!drawer) return;
    const card = mount(drawer);
    if (!card) return;
    const shouldFocus = card.contains(document.activeElement) || document.activeElement === document.body;
    card.setAttribute('aria-busy', 'false');
    card.dataset.state = success ? 'success' : 'notice';
    card.querySelector('[role=status]').textContent = message;
    if (success) {
      Array.from(card.children).filter(node => node.getAttribute('role') !== 'status').forEach(node => node.remove());
      card.tabIndex = -1;
      if (shouldFocus && drawer.classList.contains('is-open')) card.focus({ preventScroll: true });
    } else {
      noticeSignature = signature(drawer);
      const button = card.querySelector('button');
      if (button) { button.disabled = true; button.textContent = 'Review your cart'; }
    }
  }
  function signature(drawer) {
    return [drawer.classList.contains('is-open'), Array.from(drawer.querySelectorAll(PLUS)).map(button => button.dataset.cartItemKey + ':' + button.dataset.currentQuantity).join('|'), drawer.querySelector('#atlas-upsell-cart-subtotal-line-price-span')?.textContent, hasCode(drawer)].join(';');
  }
  async function sync(force = false) {
    if (busy) return;
    const drawer = root();
    if (!drawer) return;
    const currentSignature = signature(drawer);
    if (!force && currentSignature === lastSignature) return;
    lastSignature = currentSignature;
    const ticket = ++revision;
    if (!drawer.classList.contains('is-open')) return;
    if (document.getElementById(CARD)?.dataset.state === 'notice' && currentSignature === noticeSignature) return;
    // Never leave a stale, clickable offer while a shopper changes their cart.
    const oldButton = document.getElementById(CARD)?.querySelector('button');
    if (oldButton) oldButton.disabled = true;
    let state;
    try { state = classify(await readCart(), market(), hasCode(drawer), reason => { drawer.dataset.lulloEnergyUpgradeStatus = reason; }); }
    catch (_) { state = null; drawer.dataset.lulloEnergyUpgradeStatus = 'cart-unavailable'; }
    if (ticket !== revision || busy) return;
    drawer.classList.toggle('lullo-energy-cart-focused', Boolean(state));
    if (!state?.eligible || !nativeButton(drawer, PLUS, state.key, 1)) {
      if (!(state?.quantity === 2 && state.key === successKey && document.getElementById(CARD)?.dataset.state === 'success')) removeCard();
      return;
    }
    successKey = '';
    if (document.getElementById(CARD)?.dataset.state) removeCard();
    const card = mount(drawer);
    if (card) card.querySelector('button').disabled = false;
  }
  function queue(force = false) {
    forcePending = forcePending || force;
    if (timer) return;
    timer = setTimeout(() => { timer = null; const refresh = forcePending; forcePending = false; sync(refresh); }, 120);
  }
  const delay = milliseconds => new Promise(resolve => setTimeout(resolve, milliseconds));
  async function upgrade() {
    if (busy) return;
    busy = true;
    ++revision;
    const card = document.getElementById(CARD);
    const action = card?.querySelector('button');
    if (action) { action.disabled = true; action.textContent = 'Updating your cart…'; }
    card?.setAttribute('aria-busy', 'true');
    let clicked = false;
    try {
      const drawer = root();
      const before = classify(await readCart(), market(), hasCode(drawer));
      const plus = before?.eligible && nativeButton(drawer, PLUS, before.key, 1);
      if (!plus || !drawer.classList.contains('is-open')) throw new Error('changed');
      // Atlas owns line properties and re-tiers its existing offer. Never add a second full-price line.
      plus.click();
      clicked = true;
      let after;
      for (const wait of [350, 650, 1000, 1500, 2500]) {
        await delay(wait);
        after = await readCart();
        const state = classify(after, market(), hasCode(drawer));
        if (state?.quantity === 2) {
          successKey = state.key;
          drawer.classList.add('lullo-energy-cart-focused');
          showStatus('Upgraded to 2 tins · $56.99 before tax. Free standard U.S. shipping.', true);
          return;
        }
        if (![1, 2].includes(after.item_count) || after.items?.length !== 1 || String(after.items[0].variant_id) !== ENERGY || after.items[0].selling_plan_allocation) break;
      }
      // Guarded rollback only for an otherwise unchanged, incorrectly priced two-tin cart.
      const item = after?.items?.[0];
      if (after?.items?.length === 1 && after.item_count === 2 && String(item.variant_id) === ENERGY && JSON.stringify(Object.entries(item.properties || {}).sort()) === before.properties && !item.selling_plan_allocation && !hasCode(drawer) && Number(after.total_price) > 5699) {
        const latest = await readCart();
        if (latest.items?.length !== 1 || latest.items[0].key !== item.key || latest.item_count !== 2 || latest.total_price !== after.total_price || latest.items[0].selling_plan_allocation || JSON.stringify(Object.entries(latest.items[0].properties || {}).sort()) !== before.properties || hasCode(drawer)) {
          showStatus('Your cart changed. Please review the quantity and total before checkout.');
          return;
        }
        const minus = nativeButton(drawer, MINUS, item.key, 2);
        if (minus) {
          minus.click();
          await delay(1000);
          const restored = classify(await readCart(), market(), hasCode(drawer));
          if (restored?.eligible) { showStatus('The bundle could not be applied. Your cart is back to 1 tin. You can continue to checkout.'); return; }
        }
      }
      showStatus('We could not confirm the bundle. Please review the quantity and total before checkout.');
    } catch (_) {
      showStatus(clicked ? 'We could not confirm the update. Please review your cart before checkout.' : 'Your cart changed or could not be checked. No upgrade was added.');
    } finally {
      busy = false;
      // Keep the result until the cart actually changes; no automatic second attempt.
      lastSignature = '';
      queue();
    }
  }
  new MutationObserver(records => {
    const drawer = root();
    if (drawer && records.some(record => drawer.contains(record.target) || Array.from(record.addedNodes).some(node => node === drawer || node.contains?.(drawer)))) queue();
  }).observe(document.documentElement, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['class', 'data-current-quantity', 'data-cart-item-key'] });
  ['atlas-cart:changed', 'atlas:cart-updated', 'cart:update', 'cart:updated'].forEach(event => document.addEventListener(event, () => queue(true)));
  document.addEventListener('input', event => { if (event.target.matches?.('#lullo-cart-discount-code-input,#atlas-discount-code-input')) queue(true); });
  document.addEventListener('visibilitychange', () => { if (!document.hidden) queue(true); });
  queue(true);
})();
